var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex flex-column" }, [
    _c(
      "div",
      {
        staticClass: "screen-mode-and-save justify-content-end",
        class: { "screen-mode-and-save-scroll": _vm.isScroll }
      },
      [
        _c("div", { staticClass: "wrap-screen-mode justify-content-end" }, [
          _c(
            "button",
            { staticClass: "save-button", on: { click: _vm.submitForm } },
            [_vm._v("\n        Save\n      ")]
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "card-page" }, [
      _c(
        "div",
        { staticClass: "card-page-content input-field" },
        [
          _c("h6", { staticClass: "card-title-text" }, [
            _vm._v("View Information")
          ]),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-form",
                    { class: { "error-input": _vm.$v.dataSetup.title.$error } },
                    [
                      _c("label", [
                        _vm._v("Title "),
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("*")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("j-input", {
                        attrs: { placeholder: "Enter title here" },
                        model: {
                          value: _vm.dataSetup.title,
                          callback: function($$v) {
                            _vm.$set(_vm.dataSetup, "title", $$v)
                          },
                          expression: "dataSetup.title"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-form",
                    {
                      class: {
                        "error-input": _vm.$v.dataSetup.sheet_name.$error
                      }
                    },
                    [
                      _c("label", [_vm._v("Sheet Name")]),
                      _vm._v(" "),
                      _c("j-input", {
                        attrs: { placeholder: "Enter sheet name here" },
                        model: {
                          value: _vm.dataSetup.sheet_name,
                          callback: function($$v) {
                            _vm.$set(_vm.dataSetup, "sheet_name", $$v)
                          },
                          expression: "dataSetup.sheet_name"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  !_vm.dataSetup.is_use_advance_report
                    ? _c(
                        "b-form",
                        [
                          _c("label", [_vm._v("Format File")]),
                          _vm._v(" "),
                          _c("j-single-select", {
                            attrs: {
                              options: _vm.listFormatFile,
                              placeholder: "Select Format File"
                            },
                            model: {
                              value: _vm.$v.dataSetup.format_file.$model,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.$v.dataSetup.format_file,
                                  "$model",
                                  $$v
                                )
                              },
                              expression: "$v.dataSetup.format_file.$model"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _vm.advanceReportSetting && !_vm.isExternalApi
      ? _c("div", { staticClass: "card-page m__t--25" }, [
          _c(
            "div",
            { staticClass: "card-page-content input-field" },
            [
              _c("h6", { staticClass: "card-title-text" }, [
                _vm._v("Advance Report")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card-toggle-config" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-between"
                  },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("j-switch", {
                      model: {
                        value: _vm.dataSetup.is_use_advance_report,
                        callback: function($$v) {
                          _vm.$set(_vm.dataSetup, "is_use_advance_report", $$v)
                        },
                        expression: "dataSetup.is_use_advance_report"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.dataSetup.is_use_advance_report
                ? _c(
                    "b-form",
                    { staticClass: "mt-3" },
                    [
                      _c("label", [_vm._v("Format File")]),
                      _vm._v(" "),
                      _c("j-single-select", {
                        attrs: {
                          disabled: true,
                          options: _vm.listFormatFileAdvanceReport,
                          "error-required": false,
                          placeholder: "Select Format File"
                        },
                        model: {
                          value: _vm.$v.dataSetup.format_file.$model,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.$v.dataSetup.format_file,
                              "$model",
                              $$v
                            )
                          },
                          expression: "$v.dataSetup.format_file.$model"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "card-page m__t--25" }, [
      _c("div", { staticClass: "card-page-content input-field" }, [
        _c("h6", { staticClass: "card-title-text" }, [_vm._v("Column")]),
        _vm._v(" "),
        _c(
          "section",
          [
            _c(
              "draggable",
              {
                staticClass: "row",
                attrs: {
                  options: {
                    animation: 300,
                    handle: ".icon-drag"
                  }
                },
                model: {
                  value: _vm.dataSetup.columns,
                  callback: function($$v) {
                    _vm.$set(_vm.dataSetup, "columns", $$v)
                  },
                  expression: "dataSetup.columns"
                }
              },
              _vm._l(_vm.dataSetup.columns, function(data, index) {
                return _c("b-col", { key: index + 0, attrs: { cols: "12" } }, [
                  _c("div", { staticClass: "field-list py-3 mb-2" }, [
                    _c(
                      "div",
                      { staticClass: "d-flex align-items-center" },
                      [
                        _c("img", {
                          staticClass: "icon-drag",
                          attrs: {
                            src: require("@/assets/new-form-ui/dragged.svg")
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "6 pr-0" } },
                              [
                                _c("j-input", {
                                  attrs: {
                                    "error-required": false,
                                    placeholder: "Column name"
                                  },
                                  model: {
                                    value: data.name,
                                    callback: function($$v) {
                                      _vm.$set(data, "name", $$v)
                                    },
                                    expression: "data.name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "6" } },
                              [
                                _c("j-single-select", {
                                  attrs: {
                                    options: _vm.variableOptionsClass,
                                    "error-required": false,
                                    placeholder: "Select Variable"
                                  },
                                  model: {
                                    value: data.key,
                                    callback: function($$v) {
                                      _vm.$set(data, "key", $$v)
                                    },
                                    expression: "data.key"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "fa fa-trash ml-3 cursor-pointer",
                          on: {
                            click: function($event) {
                              _vm.deleteColumn(index)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              })
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "btn-add-more", on: { click: _vm.addColumn } },
          [
            _c("img", {
              staticClass: "m__r--5",
              attrs: {
                src: require("@/assets/icon/add.png"),
                height: "15",
                width: "15"
              }
            }),
            _vm._v("\n        Add Column\n      ")
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-transparent m__t--15" }, [
      _vm.formDetail.import_view
        ? _c(
            "span",
            {
              staticClass: "cursor-pointer",
              staticStyle: { "font-size": "14px" },
              on: { click: _vm.deleteView }
            },
            [
              _c("i", { staticClass: "fa fa-trash" }),
              _vm._v(" "),
              _c("small", [_vm._v("Delete this view")])
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h4", { staticClass: "title-config" }, [_vm._v("Advance Import")]),
      _vm._v(" "),
      _c("p", { staticClass: "description mb-0" }, [
        _vm._v(
          "\n              Support for importing big data to table Data Manager and including monitoring reports\n            "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c463b0e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c463b0e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/menu/jImportView.vue
// module id = null
// module chunks = 